import { useContext } from "react";
import { resumeActionTypes } from "../reducer/resume-reducer";
import { ResumeContext } from "../resume-context";

export default function useResumeUserHandler() {
    const { dispatch } = useContext( ResumeContext );

    return {
        handleChange: ( name, value ) => {
            dispatch( {
                type: resumeActionTypes.CHANGE_DOCUMENT_USER_FIELD,
                payload: { name, value },
            } );
        },
    };
}
